/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import type { Logger } from '@airasia-rn/core-logger';

const ACTIONS = {
  tap: 'tap',
  click: 'click',
  view: 'screen_view',
};

const TRACK_EVENT_NO_ECOMMERCE = 'trackEventNoEcommerce';

export const createWebLogger = (baseLogger: Logger): Logger => {
  return {
    logEvent: (event, params) => {
      const { action, category, label, screen_name, ...rest } = params || {};
      const modifiedParams = {
        event: TRACK_EVENT_NO_ECOMMERCE,
        eventAction:
          action === ACTIONS.tap
            ? ACTIONS.click
            : action === ACTIONS.view
              ? ACTIONS.view
              : action,
        eventCategory: category,
        eventLabel: label,
        screenName: screen_name,
        ...rest,
      };

      baseLogger.logEvent(event, modifiedParams);
    },

    logError: (error, context) => {
      baseLogger.logError(error, context);
    },

    logScreenView: (screen, params) => {
      const { action, category, label, ...rest } = params || {};
      const modifiedParams = {
        event: TRACK_EVENT_NO_ECOMMERCE, //Need to check if we pass this or the screen name
        eventAction: action,
        eventCategory: category,
        eventLabel: label,
        screenName: screen,
        ...rest,
      };
      baseLogger.logScreenView(screen, modifiedParams);
    },
  };
};
